import React, {type ReactNode} from 'react'
import {Location} from '@duesyco/shared'
import {MapPinIcon} from '@heroicons/react/16/solid'

interface Props {
    location: Location;
    testId?: string;
}

export default function EventLocationPill(
    {
        location,
        testId = undefined,
    }: Props): ReactNode {
    return <span
        className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full bg-storm-90 text-gray-900 text-nowrap ring-1 ring-gray-500/5 ring-inset"
        data-testid={testId}
    >
        <MapPinIcon className={'size-3 shrink-0'} aria-hidden="true"/>
        {location.name}
    </span>
}
